module.exports = __webpack_public_path__ + "site/img/elder.8fd0e46c.png";